/* eslint-disable @typescript-eslint/no-explicit-any */
import {ENDPOINT, METHOD} from '@/constants';
import {DTO} from '../base/dto';
import { IGetListLogging } from '@/types/common/logging';

export class GetListLoggingDTO extends DTO {
  public param: undefined;
  public url = ENDPOINT.LOGGING;
  public method = METHOD.GET;
  public body: unknown;
  public readonly responseClass: unknown;
  public query: IGetListLogging;
  constructor(query: IGetListLogging) {
    super();
    this.query = query;
  }
}
